// removed by extract-text-webpack-plugin
module.exports = {"containerResume":"styles__containerResume___12bYE","value_list":"styles__value_list___1TVBm","list_phones":"styles__list_phones___1Cyu6","label_ported_numbers":"styles__label_ported_numbers___ADtWn","titleResume":"styles__titleResume___1pOmO","buttonFinishSale":"styles__buttonFinishSale___2Cw3J","empty":"styles__empty___1Ew6c"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/OrderResume/styles.css
// module id = 3180
// module chunks = 0